/**
 * Type definitions for validation service responses
 * Based on Smithy model definitions
 * 
 * TODO: Generate these types automatically from Smithy models using smithy-typescript
 * This will ensure type safety and keep types in sync with the service contract.
 * 
 * Note: While Smithy defines some fields as @required, the API can return null values
 * in practice, so we use optional fields to match the actual runtime behavior.
 */

export enum ValidationExecutionStatus {
	VALIDATION_PASSED = 'VALIDATION_PASSED',
	VALIDATION_FAILED = 'VALIDATION_FAILED',
	VALIDATION_IN_PROGRESS = 'VALIDATION_IN_PROGRESS',
	VALIDATION_FATAL = 'VALIDATION_FATAL',
	// SDS validation statuses (when validationDefinition is not present)
	VALID = 'VALID',
	INVALID = 'INVALID',
	FAILED = 'FAILED',
	PENDING = 'PENDING',
}

/**
 * A result for a validation function.
 * Smithy model defines validationId, validationName, and status as @required,
 * but API responses may contain null values, so all fields are optional.
 */
export interface ValidationResult {
	validationId?: string;
	validationName?: string;
	status?: string;
	errorMessage?: string;
	workflowId?: string;
}

/**
 * Summary of validation execution that stores how many validation functions passed or failed.
 * Smithy model defines all fields as @required.
 */
export interface ValidationReport {
	totalValidations: number;
	passedValidations: number;
	failedValidations: number;
}
